'use client';

import React, { useEffect } from 'react';

interface ProductStoryModalProps {
  name: string;
  story: string;
  onClose: () => void;
}

export default function ProductStoryModal({ name, story, onClose }: ProductStoryModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center px-0 sm:px-4"
      style={{ backgroundColor: 'rgba(44,24,16,0.55)' }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`Story about ${name}`}
    >
      <div
        className="w-full sm:max-w-sm rounded-t-2xl sm:rounded-2xl p-6 pb-8"
        style={{ backgroundColor: 'var(--card)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Handle bar */}
        <div
          className="w-10 h-1 rounded-full mx-auto mb-5 sm:hidden"
          style={{ backgroundColor: 'var(--border)' }}
        />

        {/* Ornament */}
        <div className="flex justify-center mb-3">
          <span className="font-serif text-lg" style={{ color: 'var(--secondary)' }}>
            ✦
          </span>
        </div>

        <h3
          className="font-serif text-xl font-bold text-center mb-4"
          style={{ color: 'var(--primary)' }}
        >
          {name}
        </h3>
        <p
          className="text-sm leading-relaxed text-center"
          style={{ color: 'var(--muted-foreground)' }}
        >
          {story}
        </p>

        <button
          onClick={onClose}
          className="btn-primary w-full mt-6 text-sm"
        >
          Close
        </button>
      </div>
    </div>
  );
}